import { Helmet } from "react-helmet"

function PolitikaPrivatnosti() {
    return (
        <div className="flex-container full-width flex-grow-1">
            <Helmet>
                <title>Historiografija.ba | Politika privatnosti</title>
                <meta
                    name="description"
                    content="Politika privatnosti i prikupljanja kolačića"
                    data-react-helmet="true" 
                />
            </Helmet>
            <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500 text-center">Politika privatnosti</h1>
                <p>Datum zadnje izmjene: 27.02.2026.</p>
                <p>
                    Portal historiografija.ba se obavezuje da će čuvati privatnost posjetioca portala u skladu sa Opštom uredbom o zaštiti podataka (<a target="_blank" rel='noreferrer' href="https://gdpr-info.eu/">GDPR</a>). Politika privatnosti objašnjava koje informacije o posjetiocima prikupljamo i kako ih koristimo. Za sve informacije u vezi obrade i čuvanja Vaših podataka, možete pisati na email adresu: <a href="mailto:urednik@historiografija.ba">urednik@historiografija.ba</a>.
                </p>
                <p>
                    Prikupljamo informacije koje su neophodne za poboljšanje korisničkog iskustva, analizu posjećenosti dijelova portala i prikazivanje oglasa. Ove informacije prikupljamo programabilno i putem kolačića.
                </p>
                <br />

                <h2 className="font-weight-400">Šta su kolačići</h2>
                <p>
                    Kolačići su nizovi podataka koji se smještaju u Vaš web preglednik. Oni se šalju nazad portalu historiografija.ba svaki put kada posjetite neku stranicu na našem portalu. Na taj način možemo da razlikujemo korisnike i bolje razumijemo interakcije svakog individualnog korisnika sa sadržajem.
                </p>
                <br />


                <h2 className="font-weight-400">Informacije koje se prikupljaju putem kolačića i razlog prikupljanja</h2>
                <p>
                    Koristimo alat Google Analytics za analizu interakcije korisnika sa našim portalom, poput stranica portala koje posjećujete i vremena provedenog na portalu. 
                    Za više informacija o načinu na koji Google Analytics prikuplja korisničke podatke, pogledajte <a target="_blank" rel='noreferrer' href="https://policies.google.com/technologies/partner-sites">link 1</a> ili <a target="_blank" rel='noreferrer' href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">link 2</a>.
                    <br />
                    Možete da u potpunosti isključite prikupljanje kolačića od strane Google Analytics putem sljedećeg <a target="_blank" rel='noreferrer' href="https://tools.google.com/dlpage/gaoptout?hl=en">linka</a>.
                    <br />
                    Za upravljanje i prikazivanje oglasa na našoj web stranici koristimo proizvode kompanije Google. 
                    Treća lica, uključujući Google, koriste kolačiće za serviranje oglasa na osnovu prethodnih posjeta korisnika našoj web stranici ili drugim web stranicama. 
                    Google-ova upotreba reklamnih kolačića omogućava njemu i njegovim partnerima da poslužuju oglase korisnicima na osnovu njihove posjete našoj stranici i/ili drugim stranicama na internetu.
                    <br />
                    Korisnici se mogu odjaviti od personalizovanog oglašavanja od strane kompanije Google posjetom stranici <a href="https://www.google.com/settings/ads" target="blank">Podešavanja oglasa</a> na Google-u.
                </p>

                <p>
                    U skladu sa Opštom uredbom o zaštiti podataka, Vaše lične podatke možemo prikupljati i obrađivati samo ako nam date Vašu saglasnost, a do tada Vaši podaci neće biti prikupljeni.<br />
                </p>                
            </div>
        </div>
    )
}

export default PolitikaPrivatnosti
